import React, { Component } from 'react';
import PropTypes from 'prop-types';
import LocalizedStrings from 'react-localization';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { SetComponentLanguage } from '../../../helpers';
import en from './locales/en.json';
import fr from './locales/fr.json';
import './DatesModal.css';

const strings = SetComponentLanguage(LocalizedStrings, en, fr);

class DatesModal extends Component {

	toggle = () => {
		this.props.toggleDatesModal();
	}

	componentWillReceiveProps(props) {
		props.prices.forEach((price) => {
			setTimeout(() => {
				const select = document.getElementById('section' + price.section + '-price' + price.price);
				if(select !== null){
					[...select.options].some((option, index) => {
						if (option.value === price.value) {
							select.selectedIndex = index;
							return true;
						}
					});
				}
			}, 500);
		});
	}

	render() { 
		return ( 
			<div>
		  		<Modal isOpen={this.props.isDatesModalOpen} toggle={this.toggle} className="modal-price-change">
		          	<ModalHeader toggle={this.toggle}>{strings.title}</ModalHeader>
		          	<ModalBody>
						<div className="table-responsive">
							<table className="showtix-table showtix-table__theme2">
								<thead>
									<tr>
										<th className="text-center"></th>
										{ this.props.event.prices.map((price, i) =>
											[
												(price.desc !== "" &&
												<th className="text-center" key={i}>
													{price.desc}&nbsp;
													-&nbsp;
													{new Intl.NumberFormat('en-US', { 
														style: 'currency', 
														currency: 'USD' 
													}).format(price.amount)}	
												</th>
												)
											]
										)}
									</tr>
								</thead>
								<tbody>
									{ this.props.event.venue.sections.map((section, i) =>
										<tr key={i}>
											<td className="text-left">
												{section.name}
											</td>
											{ this.props.event.prices.map((price, j) =>
												[
													(price.desc !== "" &&
													<td className="text-center" key={j}>
														<div className="showtix-form__group">
															<div className="showtix-form__select">
																<select
																	className="showtix-input js-section-price"
																	section={section.id} 
																	price={price.id} 
																	id={"section" + section.id + "-price" + price.id}
																>
																	<option value="all">{strings.both}</option>
																	<option value="box-office" selected={price.isNew && parseInt(price.amount, 10) === 0}>{strings.boxOfficeOnly}</option>
																	<option value="hidden">{strings.noOne}</option>
																</select>
															</div> 
														</div>
													</td>
													)
												]
											)}
										</tr>
									)}
									
								</tbody>
							</table>
						</div> 
		          	</ModalBody>
		          	<ModalFooter className="text-center">
						<button 
						  	type="button" 
							className="showtix-button showtix-background__primary-1"
							onClick={this.props.savePricing}
						>
							<span>{strings.saveClose}</span>
						</button>
		          	</ModalFooter>
		        </Modal>
			</div>
		)
	}
}

DatesModal.propTypes = {
    event: PropTypes.shape({
        venue: PropTypes.shape({
            sections: PropTypes.array
        }),
        prices: PropTypes.array
    }),
    isDatesModalOpen: PropTypes.bool,
    toggleDatesModal: PropTypes.func,
    savePricing: PropTypes.func
}
 
export default DatesModal;


// WEBPACK FOOTER //
// ./src/components/CreateEvent/DatesModal/DatesModal.js